/// <amd-module name="VSSUI/Components/IdentityCard/ServicePrincipalCard" />

import * as React from "react";

import { Button } from "VSSUI/Button";
import { css } from "VSSUI/Util";
import { Persona } from "../Persona/Persona";
import { PersonaSize } from "../Persona/Persona.Props";
import { CardContactLine } from "./CardContactLine";
import { IContactCardProps } from "./ContactCard.Props";

export class ServicePrincipalCard extends React.Component<IContactCardProps> {
    private contactButtonRef = React.createRef<Button>();
    // Setting the focus for the case of default card mounting when we come back via back header
    public componentDidMount(): void {
        if (this.contactButtonRef.current) {
            this.contactButtonRef.current.focus();
        }
    }

    // Render
    public render(): JSX.Element {
        const { identity } = this.props;
        const { displayName, mail, originId } = identity;

        return (
            <div className={css("bolt-identity-card-content flex-column scroll-hidden", "bolt-identity-default-card-without-header")}>
                <div className="flex-row">
                    <Persona className="bolt-identity-card-persona-main" size={PersonaSize.size72} identity={this.props.identity} />
                    <div className="flex-column flex-grow bolt-identity-card-name scroll-hidden">
                        <div className="word-wrap title-s">{displayName}</div>
                        <div className="word-wrap">{mail}</div>
                    </div>
                </div>
                <div className="flex-column scroll-hidden">
                    <div className="bolt-identity-default-card-info-wrapper ">
                        <hr className="bolt-identity-card-hr" />

                        <div className="bolt-identity-default-card-contact-info-container flex-column scroll-hidden">
                            {originId && <CardContactLine iconName="ContactCard" content={originId} />}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
